import { Observable, of } from 'rxjs';
import { filter, take, mergeMap } from 'rxjs/operators';

import { PusherService } from '../../services/pusher-service';
import { CUSTOMER_IMPORT_JOB_COMPLETE } from '../../services/pusher-service/pusher-contract-messages';

export const handleCustomerImport = (batchId) => {
  return new Observable((observer) => {
    const onMessage = (message) => observer.next(message);
    const unbindFromEvent = PusherService.bindToEvent(CUSTOMER_IMPORT_JOB_COMPLETE, onMessage);
    return () => unbindFromEvent();
  }).pipe(
    filter((pusherMessage) => pusherMessage.jobId === batchId),
    take(1),
    mergeMap(() => {
      return of({ batchId });
    }),
  );
};
